import React from "react";
import "./screenLoader.css";

const Screen_loader = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      <div className="loader_screen"></div>
    </div>
  );
};

export default Screen_loader;
